import { FC, useState } from "react";
import Video from "@/components/Video";
import playIcon from "@/assets/icons/play.svg";

interface ClientsSayItemProps {
  isMobile: boolean;
  img_src: string;
  img_mob_src: string;
  alt: string;
  video_src: string;
  name: string;
  description: string;
}

const ClientsSayItem: FC<ClientsSayItemProps> = ({
  isMobile,
  img_src,
  img_mob_src,
  alt,
  video_src,
  name,
  description,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const clickHandle = () => {
    setIsDialogOpen(true);
  };

  return (
    <div className="w-[250px] md:w-full">
      <button
        onClick={clickHandle}
        className="group relative flex h-[270px] w-[250px] flex-1 cursor-pointer flex-col items-center justify-end overflow-hidden rounded-[22px] px-2 pb-7.5 md:h-[510px] md:w-full"
      >
        <img
          src={isMobile ? img_mob_src : img_src}
          alt={alt}
          loading="lazy"
          className="absolute inset-0 z-0 h-full w-full object-cover"
        />
        <div className="relative z-10 flex w-full items-center justify-between rounded-lg border border-gray-200 bg-transparent p-[12px] backdrop-blur-[4px] md:p-[16px]">
          <div className="flex h-min flex-col items-start self-center text-left text-white">
            <h4 className="text-lg font-medium md:text-xl">{name}</h4>
            <p className="text-[13px] md:text-sm">{description}</p>
          </div>
          <div className="text-dark flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-full bg-white">
            <img
              src={playIcon}
              className="group-hover:opacity-80"
              loading="lazy"
              alt="Play"
            />
          </div>
        </div>
      </button>
      <Video
        video_src={video_src}
        isDialogOpen={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
      ></Video>
    </div>
  );
};

export default ClientsSayItem;
